/* eslint-disable jira/naming/disallow-filenames */
/* eslint-disable import/order */
// eslint-disable-next-line jira/filename-case
import React, { useEffect, useRef } from 'react';
import {
	CORE_PROJECT,
	SERVICE_DESK_PROJECT,
	SOFTWARE_PROJECT,
} from '@jira/platform__project-types/src/project-types.tsx';
import {
	useAnalyticsEvents as useAnalyticsEventsDI,
	fireUIAnalytics as fireUIAnalyticsDI,
} from '@atlassian/jira-product-analytics-bridge';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { useSpaStateTransition as useSpaStateTransitionDI } from '@atlassian/jira-spa-state-controller/src/components/transition-state/index.tsx';
import {
	useResource as useResourceDI,
	useRouter as useRouterDI,
	Redirect as RedirectDI,
} from '@atlassian/react-resource-router';
import type { RedirectProps } from './types.tsx';
/**
 * Facilitates navigating to a specific project page based on its type. This includes
 * tracking the navigation event for analytics purposes and determining the correct URL.
 * The function supports SPA transitions and ensures that analytics are correctly
 * captured during the initial render.
 */
export const RedirectToProjectType = ({
	Redirect = RedirectDI,
	fireUIAnalytics = fireUIAnalyticsDI,
	page,

	useAnalyticsEvents = useAnalyticsEventsDI,

	useResource = useResourceDI,

	useRouter = useRouterDI,

	useSpaStateTransition = useSpaStateTransitionDI,
}: RedirectProps): React.JSX.Element | null => {
	const [{ match, query, route }] = useRouter();

	const { data } = useResource(projectContextResource);

	const { createAnalyticsEvent } = useAnalyticsEvents();

	const [{ isInitialRender: isInitial }] = useSpaStateTransition();
	const eventRef = useRef(createAnalyticsEvent({}));
	useEffect(() => {
		if (!data || !route || !eventRef.current) return;
		fireUIAnalytics(eventRef.current, 'route redirected', {
			isInitial,
			routeName: route.name,
		});
		// @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
		eventRef.current = null;
	}, [data, fireUIAnalytics, isInitial, route]);
	if (!data || !route) return null;
	const { projectKey, projectType, simplified } = data;
	let type;
	switch (projectType) {
		case SERVICE_DESK_PROJECT:
			type = 'servicedesk';
			break;
		case CORE_PROJECT:
			type = 'core';
			break;
		case SOFTWARE_PROJECT:
		default:
			type = `software${simplified ? '' : '/c'}`;
	}
	const returnPage = typeof page === 'string' ? page : page(match, query);
	return <Redirect to={`/jira/${type}/projects/${projectKey}${returnPage}`} />;
};
